import { Component } from '@angular/core';
import { SharedService, JackpotService } from 'baseline-lib';
import { NavController} from 'ionic-angular';
import { JackpotDetailPage } from '../jackpot-detail/jackpot-detail';


/**
 * Generated class for the JackpotComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'jackpot',
  templateUrl: 'jackpot.html'
})
export class JackpotComponent {

  text: string;

  constructor(private _sharedService: SharedService, public navCtrl : NavController,
    private jackpotService: JackpotService) 
  {
    console.log('Hello JackpotComponent Component');
  }

  ngOnInit() {   
    this.jackpotService.getJackpotEvents();
    console.log("Data is "+this.jackpotService.jackpotEventList)
  }  

  joinNowButtonClicked(jevent : any)
  {
    this.navCtrl.push(JackpotDetailPage, {data : jevent})
  }

  ngOnDestroy() {
    this.jackpotService.clearJackpotData();
  }

}



// WEBPACK FOOTER //
// ./src/app/sports/jackpot/jackpot.ts